import React, { useState } from 'react';
import * as pdfjsLib from 'pdfjs-dist';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';

// Set worker source
// Use local worker file from public directory
pdfjsLib.GlobalWorkerOptions.workerSrc = `'/pdf.worker.min.mjs'`;

const PdfToImage = () => {
    const [file, setFile] = useState(null);
    const [converting, setConverting] = useState(false);
    const [error, setError] = useState('');
    const [progress, setProgress] = useState(0);
    const fileInputRef = React.useRef(null);

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);
        setError('');
        setProgress(0);
    };

    const handleConvert = async (e) => {
        // Blur the button to remove focus state
        if (e && e.target) {
            e.target.blur();
        }

        if (!file) {
            setError('Please select a PDF file first.');
            return;
        }

        if (file.type !== 'application/pdf') {
            setError("Invalid file type. Please upload a PDF file.");
            return;
        }

        setConverting(true);
        setError('');
        setProgress(0);

        try {
            const arrayBuffer = await file.arrayBuffer();
            const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
            const totalPages = pdf.numPages;
            const zip = new JSZip();

            for (let i = 1; i <= totalPages; i++) {
                const page = await pdf.getPage(i);
                const viewport = page.getViewport({ scale: 2.0 }); // High quality
                const canvas = document.createElement('canvas');
                const context = canvas.getContext('2d');
                canvas.height = viewport.height;
                canvas.width = viewport.width;

                await page.render({ canvasContext: context, viewport: viewport }).promise;

                const imgData = canvas.toDataURL('image/png').split(',')[1];
                zip.file(`page-${i}.png`, imgData, { base64: true });

                setProgress(Math.round((i / totalPages) * 100));
            }

            const content = await zip.generateAsync({ type: 'blob' });
            saveAs(content, `${file.name.replace('.pdf', '')}-images.zip`);

            // Clear file selection after successful conversion
            setFile(null);
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }

        } catch (err) {
            console.error(err);
            setError('Error converting file. Please try again.');
        } finally {
            setConverting(false);
            setProgress(0);
        }
    };

    return (
        <div className="converter-section">
            <h2>PDF to Image</h2>

            <div className="input-group">
                <input
                    type="file"
                    accept="application/pdf"
                    onChange={handleFileChange}
                    ref={fileInputRef}
                />
            </div>

            {error && <div className="error-message">{error}</div>}

            <button
                onClick={handleConvert}
                disabled={converting || !file}
                className="convert-btn"
            >
                {converting ? `Converting... ${progress}%` : 'Convert to Images (ZIP)'}
            </button>

            {converting && <div className="loading-indicator">Processing... {progress}%</div>}
        </div>
    );
};

export default PdfToImage;
